export default __webpack_public_path__ + "static/media/logo.ca503848.svg";